import React, { useState, useCallback } from "react";
import { Icon, Card, Button, SheetContainer, Text, Spinner, Stack, CollapsedText } from "@bookingcom/bui-react";
import { SparklesIcon } from "@bookingcom/bui-assets-react/streamline";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import styles from "./GenAiSearchSummary.module.css";
const GenAiSearchSummary = ({ variant = "card", className, modalPosition = "center", summaryText, isLoading, isError, onCtaClick, onModalClose }) => {
    const i18n = useI18n();
    const [summaryVisible, setSummaryVisible] = useState(false);
    const ctaClickHandler = useCallback(() => {
        setSummaryVisible(true);
        onCtaClick?.();
    }, [onCtaClick]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: className },
            variant === "card" && React.createElement(GenAiCard, { onCtaClick: ctaClickHandler }),
            variant === "collapsed_text" && (React.createElement(GenAiCollapsedText, { summaryText: summaryText, isLoading: isLoading, isError: isError, onCollapsedTextClick: ctaClickHandler }))),
        variant === "card" ? (React.createElement(SheetContainer, { active: summaryVisible, position: modalPosition, title: i18n.trans(t("flights_sr_genai_modal_search_summary_heading")), onCloseTrigger: () => {
                setSummaryVisible(false);
                onModalClose?.();
            }, closeAriaLabel: i18n.trans(t("a11y_flights_sr_genai_summary_close")) },
            React.createElement("div", { className: styles.modalContent },
                React.createElement(ModalContent, { text: summaryText, isLoading: isLoading, isError: isError })))) : null));
};
const GenAiCard = ({ onCtaClick }) => {
    const i18n = useI18n();
    return (React.createElement(Card, null,
        React.createElement(Text, { variant: "strong_1", tagName: "h2", className: styles.cardTitle }, i18n.trans(t("flights_sr_genai_search_summary_title"))),
        React.createElement(Text, { variant: "body_2", className: styles.cardSubtitle }, i18n.trans(t("flights_sr_genai_search_summary_subtitle_stops_prices"))),
        React.createElement(Button, { variant: "secondary", icon: SparklesIcon, wide: true, onClick: onCtaClick }, i18n.trans(t("flights_sr_genai_search_summary_cta")))));
};
const GenAiCollapsedText = ({ summaryText, isLoading, isError, onCollapsedTextClick }) => {
    const i18n = useI18n();
    let content;
    if (isLoading) {
        content = i18n.trans(t("flights_sr_genai_summary_loading_creating_automated"));
    }
    else if (isError) {
        content = i18n.trans(t("flights_sr_genai_summary_error_couldnt_load"));
    }
    else {
        content = summaryText;
    }
    return (React.createElement(Stack, null,
        React.createElement(Stack.Item, null,
            React.createElement(Stack, { direction: "row", alignItems: "center", gap: 2 },
                isLoading ? React.createElement(Spinner, { size: "medium" }) : React.createElement(Icon, { svg: SparklesIcon, size: "medium", color: "action" }),
                React.createElement(Text, { variant: "strong_1", tagName: "h2" }, i18n.trans(t("flights_sr_genai_search_summary_title"))))),
        React.createElement(Stack.Item, null,
            React.createElement(CollapsedText, { text: content, readMoreLabel: i18n.trans(t("flights_sr_genai_summary_view_more")), readLessLabel: i18n.trans(t("flights_sr_genai_summary_view_less")), attributes: {
                    onClick: () => {
                        onCollapsedTextClick?.();
                    }
                } }))));
};
const ModalContent = ({ text, isLoading, isError }) => {
    const i18n = useI18n();
    let content;
    if (isLoading) {
        content = (React.createElement(Stack, { direction: "row", alignItems: "center", gap: 2 },
            React.createElement(Spinner, { size: "small" }),
            React.createElement(Text, { variant: "body_2" }, i18n.trans(t("flights_sr_genai_search_summary_loading")))));
    }
    else if (isError) {
        content = React.createElement(Text, { variant: "body_2" }, i18n.trans(t("flights_sr_genai_modal_search_summary_loading_error")));
    }
    else {
        const textPieces = text.split(/{start_bold}|{end_bold}/);
        content = (React.createElement("div", null, textPieces.map((piece, index) => {
            const isItBoldPiece = index % 2 === 1;
            return isItBoldPiece ? React.createElement("strong", null, piece) : piece;
        })));
    }
    return content;
};
export default GenAiSearchSummary;
